import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/shell/AppShell';
import { RequireAuth } from '@/auth/RequireAuth';
import { RequireMember } from '@/auth/RequireMember';
import { RequireAdmin } from '@/auth/RequireAdmin';
import { Settings } from '@/routes/Settings';
import { SignInPage, SignUpPage } from '@/routes/AuthPages';
import { Today } from '@/routes/Today';
import { Companies } from '@/routes/Companies';
import { Leads } from '@/routes/Leads';
import { Pipeline } from '@/routes/Pipeline';
import { DealDetail } from '@/routes/DealDetail';
import { CompanyDetail } from '@/routes/CompanyDetail';
import { Contacts } from '@/routes/Contacts';
import { ContactDetail } from '@/routes/ContactDetail';
import { Prospecting } from '@/routes/Prospecting';
import { ProspectDetail } from '@/routes/ProspectDetail';
import { Phone } from '@/routes/Phone';

export function App() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* Signed in to Clerk AND an invited workspace member. */}
      <Route element={<RequireAuth />}>
        <Route element={<RequireMember />}>
          <Route element={<AppShell />}>
            <Route index element={<Today />} />
            <Route path="leads" element={<Leads />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="deals/:id" element={<DealDetail />} />
            <Route path="companies" element={<Companies />} />
            <Route path="companies/:id" element={<CompanyDetail />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="contacts/:id" element={<ContactDetail />} />
            <Route path="prospecting" element={<Prospecting />} />
            <Route path="prospecting/:id" element={<ProspectDetail />} />
            <Route path="phone" element={<Phone />} />
            <Route element={<RequireAdmin />}>
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
